import { GameTopBarProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTopBarProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ClockProperties } from "@lib/titan2/dist/game/control/properties/ClockProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
/**
 * TopBarPortraitProperties.ts
 */
export class TopBarPortraitProperties extends GameTopBarProperties {
    constructor() {
        super();
        this.backgroundProperties = new SpriteProperties(SlingoStyle.NAVIGATION_BACKGROUND, GameStyle.MODULE);
        this.gameIdProperties = new TextFieldProperties(FontStyle.MESSAGE_BAR);
        this.clockProperties = new ClockProperties(FontStyle.CLOCK);
        this.fieldOffset = -66;
        this.fullScreenOffset = 75;
        this.backgroundProperties.position.set(512, 0);
        this.backgroundProperties.anchor.set(0.5, 0);
        this.clockProperties.position.set(1230, 4);
        this.clockProperties.horizontalAlign = ControlConstants.RIGHT;
        this.gameIdProperties.position.set(50, 10);
        this.gameIdProperties.size = new Point(230, 50);
        this.gameIdProperties.horizontalAlign = ControlConstants.LEFT;
    }
}
//# sourceMappingURL=TopBarPortraitProperties.js.map